<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Mark Filed'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (filingPeriod) {
        <tidy-row>
          <tidy-text
            [body]="filingPeriod"
            [translate]="false" />
        </tidy-row>
      }
      <tidy-card>
        <tidy-row class="field-bottom-padding">
          <tidy-datepicker
            [label]="'Filed On'"
            formControlName="filed_on"
            [form]="form.controls.filed_on"
            [submitted]="submitted"
            [errorMessage]="'Please select a date.'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            formControlName="remitted_amount"
            [form]="form.controls.remitted_amount"
            [label]="'Amount Remitted ($)'"
            [icon]="'assets/svg/cash-outline.svg'"
            [type]="'number'"
            [errorMessage]="'Please enter an amount of 0 or more.'"
            [submitted]="submitted" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            formControlName="confirmation_number"
            [form]="form.controls.confirmation_number"
            [label]="'Confirmation Number'"
            [icon]="'assets/svg/receipt-outline.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'The number the tax portal gives when the return goes in.'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding extra-top-padding">
          <tidy-input
            formControlName="filed_by"
            [form]="form.controls.filed_by"
            [label]="'Filed By'"
            [icon]="'assets/svg/person-outline.svg'" />
        </tidy-row>
      </tidy-card>

      @if (errorMessage) {
        <tidy-error-message [text]="errorMessage" />
      }

      <tidy-button
        [text]="'Mark Filed'"
        [action]="boundSave"
        [disabled]="saving"
        class="primary" />
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
